import useTranslation from 'next-translate/useTranslation';

//components
import Tabs from '@/components/base/Tabs';

export const GlobalPreviewResponsive = ({ children }) => {
    const { t } = useTranslation('scheduler');

    return (
        <Tabs
            tabs={[{ label: t('feed.your_feed') }, { label: t('feed.upcoming_posts') }]}
            defaultIndex={0}>
            {children}
        </Tabs>
    );
};
